(function ($, Drupal) {
	'use strict'

	Drupal.behaviors.promoLane = {
		attach: function (context) {
			var promoWrapper = $('.paragraph--reference-promo-lane-component .field-add-reference-promo-lane', context);
			promoWrapper.each(function() {
				if($(this)[0].children.length < 3) {
					$(this).addClass('justify-center')
				}
			})
		}
	}

}) (jQuery, Drupal)